import {
  Button,
  Dialog,
  DialogTitle,
  Container,
  Select,
  Typography,
  Box,
  MenuItem,
  DialogContent,
  DialogActions,
  LinearProgress,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import MaterialTable from "material-table";
import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import { getSessionData } from "../../../base/helper/baseHelper";
import { getSuppliers } from "../../../Ancillary/SupplierManagement/helper/supplierManagementHelper";
import SelectableSearch from "../../../base/views/SelectableSearch";
import LandingPageFooter from "../../../LandingPage/views/LandingPageFooter";
import { addCatalogCurrent } from "../helpers/uploadCatalogHelper";
import { useCatalogStage } from "../helpers/useCatalogStage";
import {
  info,
  success,
  warning,
} from "../../../../../store/notification/actions";
import { PRIMARY_COLOR } from "../../../../constants/baseConstants";
import axiosInstance from "../../../../../axiosInstance";
import LoadingButton from "../../../base/views/LoadingButton";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& .MuiPaper-root": {
      backgroundColor: "rgba(255,255,255,0.5)",
      backdropFilter: "blur(6px)",
      borderRadius: "15px",
      padding: "10px",
      // marginTop: "1%",
      justifyContent: "center",
      alignItems: "center",
    },
  },
  container: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderRadius: "5px",
    display: "flex",
    justifyContent: "space-between",
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(8px)",
    width: "100%",
  },
  form: {
    display: "flex",
    justifyContent: "space-between",
    // border : "2px solid red",
    marginTop: "0.4rem",
  },
  showpath: {
    padding: "0.5rem",
    marginRight: "1rem",
  },
  button: {
    marginRight: "1rem",
    borderRadius: "0.5rem",
  },
}));

const initialColMapping = [
  { excel: "", db: "upc_number", required: true },
  { excel: "", db: "ndc_number", required: true },
  { excel: "", db: "pack_size_qty", required: true },
  { excel: "", db: "current_catalog_price", required: true },
  { excel: "", db: "material_size", required: true },
  { excel: "", db: "material_description", required: false },
  { excel: "", db: "rx_indicator", required: false },
  { excel: "", db: "form", required: false },
];

function UploadCatalog() {
  const classes = useStyles();
  const [userId, setUserId] = useState("");
  const [storeId, setStoreId] = useState("");
  const [errors, setErrors] = React.useState({});
  const [file, setFile] = useState(null);
  const [excelDbColMapping, setExcelDbColMapping] = useState(initialColMapping);
  const [rowHeaders, setRowHeaders] = useState([]);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [supplierData, setSupplierData] = React.useState({
    load: false,
    values: [],
  });
  const [supplier, setSupplier] = useState({});
  const {
    catalog,
    isLoading: catalogLoading,
    refresh: refreshCatalog,
  } = useCatalogStage(supplier?.id, storeId);

  useEffect(() => {
    const store = JSON.parse(getSessionData({ key: "store" }));
    setUserId(getSessionData({ key: "userId" }));
    setStoreId(store.storeid);
  }, []);

  const loadSupplierDropdown = () => {
    setSupplierData({ ...supplierData, load: true });
    getSuppliers(storeId)
      .then((response) => {
        let dropdownData = [];
        if (response.data.length)
          dropdownData = response.data.map((obj) => ({
            id: obj.supplier_id,
            optionname: obj.aliasname,
          }));
        setSupplierData({ load: false, values: dropdownData });
      })
      .catch((err) => {});
  };

  const fileSelected = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;
    setFile(selectedFile);
    setExcelDbColMapping(initialColMapping);
    setUploadProgress(0);

    const fileReader = new FileReader();
    info("Reading File. Please wait");
    fileReader.onload = (e) => {
      const arrayBuffer = e.target.result;
      const workbook = XLSX.read(arrayBuffer, { type: "array" });
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];

      const firstRowData = XLSX.utils.sheet_to_json(worksheet, {
        header: 1,
        range: 0,
      });

      setRowHeaders(firstRowData[0]);
      success("File imported");
    };
    fileReader.readAsArrayBuffer(selectedFile);
  };

  const handleSupplierChange = (event, value) => {
    setSupplier(value);
  };

  function setColMapping(value, dbCol) {
    setExcelDbColMapping((prev) => {
      prev.forEach((col) => {
        if (col["db"] === dbCol) col.excel = value;
      });
      return [...prev];
    });
  }

  const validate = () => {
    const temp = {};
    if (!supplier.id) temp.supplier = "Supplier is required";
    if (!file) temp.file = "File is required";
    setErrors(temp);

    return Object.values(temp).filter((i) => i != "").length < 1;
  };

  async function addCatalogStage(e) {
    if (!validate()) return;
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("supplier_id", supplier?.id);
      formData.append("user_id", userId);
      formData.append("store_id", storeId);
      formData.append("column_mapping", JSON.stringify(excelDbColMapping));

      info("Uploading file");
      try {
        setUploadProgress(0);
        await axiosInstance.post("/physicalInventory/uploadCatalog", formData, {
          headers: {
            Accept: "multipart/form-data",
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progress) => {
            const percentCompleted = Math.round(
              (progress.loaded * 90) / progress.total
            );
            setUploadProgress(percentCompleted);
            if (percentCompleted > 89) {
              info("Processing...");
            }
          },
        });
        setUploadProgress(100);
        success("Data imported successfully!");
        setFile(null);
        refreshCatalog();
      } catch (error) {
        setUploadProgress(0);
        warning(error.response?.data?.message || error.message);
      }
    } catch (error) {}
  }

  async function saveCatalogCurrent() {
    try {
      await addCatalogCurrent(storeId, supplier.id);
      refreshCatalog();
    } catch (error) {}
  }

  return (
    <div>
      <Container maxWidth="xl" className={classes.container}>
        <div
          style={{
            width: "23%",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div style={{ width: "100%" }}>
            <SelectableSearch
              autoFocus
              data={supplierData}
              name="supplier"
              label="Supplier"
              id="supplier"
              loading={loadSupplierDropdown}
              onChangeEvent={handleSupplierChange}
              variantType="standard"
              {...(errors.supplier && {
                error: true,
                helperText: errors.supplier,
              })}
            ></SelectableSearch>
          </div>
        </div>

        <form className={classes.form}>
          <div className={classes.showpath}>
            {file ? (
              <p>{file.name.substring(0, 20)}...</p>
            ) : errors.selectedFile ? (
              <p style={{ color: "red" }}>No file choosen</p>
            ) : (
              <p>No file choosen</p>
            )}
          </div>
          <label htmlFor="contained-button-file">
            <input
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              id="contained-button-file"
              type="file"
              style={{ display: "none" }}
              multiple={false}
              onChange={fileSelected}
            />

            <Button
              className={classes.button}
              variant="contained"
              color="primary"
              style={{ backgroundColor: PRIMARY_COLOR }}
              disabled={!supplier.id}
              component="span"
            >
              Select File
            </Button>
          </label>
          <div>
            <Button
              fullWidth
              className={classes.button}
              variant="contained"
              onClick={saveCatalogCurrent}
              color="primary"
              disabled={catalog.length === 0 || !supplier.id}
              style={{ backgroundColor: PRIMARY_COLOR }}
            >
              Submit
            </Button>
          </div>
        </form>
      </Container>
      <div className={classes.root}>
        <MaterialTable
          title=""
          isLoading={catalogLoading}
          columns={[
            {
              title: "UPC",
              field: "upc",
            },
            { title: "NDC", field: "ndc" },
            {
              title: "Pack Size Quantity",
              field: "pack_size_qty",
            },
            {
              title: "Catalog Price",
              field: "current_catalog_price",
            },
            { title: "RX Indicator", field: "rx_indicator" },
            { title: "Form", field: "form" },
            { title: "Material Description", field: "material_description" },
          ]}
          data={catalog}
          options={{
            maxBodyHeight: 670,
            paging: true,
            pageSize: 25,
            pageSizeOptions: [25, 50, 100],
            headerStyle: {
              backgroundColor: "rgba(255,255,255,1)",
              color: "black",
            },
          }}
        />
      </div>
      <Dialog open={file}>
        <DialogTitle style={{ backgroundColor: PRIMARY_COLOR, color: "white" }}>
          Please map your uploaded attributes to the DB attributes
        </DialogTitle>
        <form onSubmit={addCatalogStage}>
          <DialogContent>
            <Box>
              <Box
                style={{
                  display: "flex",
                  justifyContent: "space-evenly",
                  padding: 5,
                  borderBottom: "1px solid gray",
                }}
              >
                <Typography variant="h6" style={{ width: 200 }}>
                  Uploaded Attribute
                </Typography>
                <Typography variant="h6" style={{ width: 200 }}>
                  DB Attribute
                </Typography>
              </Box>
              {excelDbColMapping.map((col) => (
                <Box
                  key={col.db}
                  style={{
                    display: "flex",
                    justifyContent: "space-evenly",
                    padding: 5,
                  }}
                >
                  <Select
                    onChange={(e) => setColMapping(e.target.value, col.db)}
                    value={col.excel}
                    style={{ width: 200 }}
                    required={col.required}
                  >
                    {rowHeaders.map((header) => (
                      <MenuItem key={header} value={header}>
                        {header}
                      </MenuItem>
                    ))}
                  </Select>
                  <Typography style={{ width: 200 }}>
                    {col.db}
                    {col.required && " *"}
                  </Typography>
                </Box>
              ))}
            </Box>
          </DialogContent>
          <DialogActions>
            <LoadingButton
              variant="contained"
              type="submit"
              loading={uploadProgress > 0 && uploadProgress < 100}
              style={{ backgroundColor: PRIMARY_COLOR, color: "white" }}
            >
              Upload
            </LoadingButton>
            <Button
              style={{ backgroundColor: "red", color: "white" }}
              onClick={() => {
                setFile(null);
                setRowHeaders([]);
              }}
              color={"error"}
              disabled={uploadProgress > 0 && uploadProgress < 100}
            >
              Close
            </Button>
          </DialogActions>
        </form>
        <LinearProgress variant="determinate" value={uploadProgress} />
      </Dialog>
      <LandingPageFooter />
    </div>
  );
}

export default UploadCatalog;
